import formatFileSize from './utils'

const messages = {
  _default: () => `vigane väärtus.`,
  after: (field, [target, inclusion]) =>
    `peab olema pärast ${inclusion ? 'või võrdne ' : ''}${target}.`,
  alpha_dash: () =>
    `võib sisaldada nii tähtmärke, numbreid kui ka kriipse ja alakriipse.`,
  alpha_num: () =>
    `võib sisaldada ainult tähemärke ja numbreid.`,
  alpha_spaces: () =>
    `võib sisaldada ainult tähtmärke ja tühikuid.`,
  alpha: () => `väli võib sisaldada ainult tähtmärke.`,
  before: (field, [target, inclusion]) =>
    `peab olema enne ${inclusion ? 'või võrdne ' : ''}${target}.`,
  between: (field, [min, max]) =>
    `peab olema vahemikus ${min} ja ${max}.`,
  confirmed: () => `kinnitus ei ühti.`,
  credit_card: () => `vigane väli.`,
  date_between: (field, [min, max]) =>
    `peab olema vahemikus ${min} ja ${max}.`,
  date_format: (field, [format]) =>
    `peab olema formaadis ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `võib sisaldada ainult numreid ${
      !decimals || decimals === '*' ? '' : decimals
    } komakohtadega.`,
  digits: (field, [length]) =>
    `võib sisalda ainult ${length} arvu numbreid.`,
  dimensions: (field, [width, height]) =>
    `peab olema ${width} pikslit lai ja ${height} pixels kõrge.`,
  email: () => `peab olema kehtiv email.`,
  ext: () => `peab olema kehtiv fail.`,
  image: () => `peab olema pilt.`,
  in: () => `peab olema kehtiv väärtus.`,
  integer: () => `peab olema täisarv.`,
  ip: () => `peab olema kehtiv ip aadress.`,
  length: (field, [length, max]) => {
    if (max) {
      return `tagastuspaki lubatud pikkus vahemikus ${length} ja ${max}.`
    }

    return `lubatud pikkus ${length}.`
  },
  max: (field, [length]) =>
    `ei või olla suurem kui ${length} tähemärki.`,
  max_value: (field, [max]) => `peab olema ${max} või väiksem.`,
  mimes: () => `peab olema õige faili tüüp.`,
  min: (field, [length]) =>
    `peab olema vähemalt ${length} tähemärki.`,
  min_value: (field, [min]) => `peab olema ${min} või rohkem.`,
  not_in: () => `peab olema kehtiv väärtus.`,
  numeric: () => `võib sisalda ainult numbreid.`,
  regex: () => `vale formaat.`,
  required: () => `kohtuslik.`,
  size: (field, [size]) =>
    `suurus peab olema väiksem kui ${formatFileSize(size)}.`,
  url: () => `vigane URL.`,
  fullName: () => 'vigane (nimi max 120 tähemärki)',
  emailInput: () => 'peab olema kehtiv e-matkahuolto aadress.',
  fullNamePerCountry: () => 'vigane (nimi max 18 tähemärki)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'et',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/et.js